import React, { useEffect, useState } from 'react'
import {
    Routes,
    Route,
    Navigate,
    useLocation,
} from "react-router-dom"
import { config_path } from './config.path'
import { clearSession, getData } from '../utils/common';
import LoginPage from '../pages/login/LoginController';
import HomeController from '../pages/home/HomeController';
import ForgotPasswordController from '../pages/forgot-password/ForgotPasswordController';
import CreatePasswordController from '../pages/create-password/CreatePasswordController';
import ChangePasswordController from '../pages/change-password/ChangePasswordController';

export default function Routers(props) {
    return (
        <Routes>
            <Route path={config_path.create_password} element={<CheckSession><CreatePasswordController /></CheckSession>} />
            <Route path={config_path.change_password} element={<CheckSession><ChangePasswordController /></CheckSession>} />
            <Route exact path="/" element={<CheckSession><LoginPage /></CheckSession>} />
            <Route path={config_path.login} element={<CheckSession><LoginPage /></CheckSession>} />
            <Route path={config_path.forgot_password} element={<ForgotPasswordController />} />
            <Route path={config_path.home} element={<RequireAuth><HomeController /></RequireAuth>} />
            {/* <Route path={config_path.home} element={<HomeController />} /> */}
        </Routes>
    )
}


function RequireAuth({ children }: { children: JSX.Element }) {
    var session = getData();
    let location = useLocation();
    console.log("AAAA RequireAuth location.pathname:", location.pathname);
    if (!session) {
        clearSession();
        return <Navigate to={config_path.login} state={{ from: location }} replace />;
    } else {
        return children;
    }
}

function CheckSession({ children }: { children: JSX.Element }) {
    var session = getData();
    let location = useLocation();
    if (!session) {
        clearSession();
        return children;
    } else {
        return <Navigate to={config_path.home} state={{ from: location }} replace />;
    }
}
